export enum TipoOrdenacao {
  DISTANCIA = 'DISTANCIA',
  NOME = 'NOME'
}
